<div *ngIf="control && isDisplayError">
    <div *ngIf="!(control.invalid && control.dirty) && isDisplayError" class="text-success"></div>
    <div class="text-danger" *ngIf="control.invalid && control.dirty && isDisplayError">{{showError}}</div>
</div>